function PageViewport({ pageId, subpage, children }) {
  const routeClass = subpage ? `is-${pageId}-${subpage}` : `is-${pageId}`;

  return (
    <div className={`pageViewport ${routeClass}`}>
      <div className="pageViewportContent">
        {children}
      </div>
    </div>
  );
}

export default PageViewport;
